<template>
  <div class="page">
    <van-nav-bar title="实习月报" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <van-tabs type="line" v-model="active" animated color="#0088F8" @click="tabsChange">
      <van-tab title="写月报">
        <!-- <van-notice-bar color="#F85352" background="#fae6e5" left-icon="info-o" mode="closeable">只能提交最近{{ delayDay }}天的实习日志记，提交时间限制在每日{{ lastTime }}之前</van-notice-bar> -->
        <van-form @submit="onSubmit" style="height: calc(100vh - 130px)">
          <van-field v-model="form.bt" name="标题" label="标题" input-align="right" error-message-align="right" placeholder="请输入" :rules="[{ required: true, message: '请填写标题' }]" />
          <van-field v-model="form.ny" is-link readonly label="选择日期" input-align="right" error-message-align="right" placeholder="请选择" @click="showDatePicker" :rules="[{ required: true, message: '请选择日期' }]" />
          <van-field style="margin-top: 10px" class="textarea" v-model="form.nr" rows="5" autosize label="内容" type="textarea" placeholder="请输入内容" :rules="[{ required: true, message: '请输入日志内容' }]" />
          <van-field name="uploader" label="">
            <template #input>
              <van-uploader accept="image/*" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" :max-count="1" :after-read="upload" v-model="fileList" />
            </template>
          </van-field>
          <div class="map">
            <el-amap ref="map" class="amap-box" :vid="'amap-vue'" :amap-manager="amapManager" :plugin="plugin"></el-amap>
          </div>
          <div class="position" v-if="schoolCode !== '10848'">
            <div class="title">
              <div>您当前所在位置</div>
              <div style="color: #0189F9;" @click="rePosition">重新定位</div>
            </div>
            <div class="content">
              <van-loading v-if="form.dz == ''" type="spinner" size="14" />
              {{ form.dz || '定位获取中…' }}
            </div>
          </div>
          <div class="button-box">
            <van-button round type="info" native-type="submit">提交</van-button>
          </div>
        </van-form>
      </van-tab>
      <van-tab title="历史月报">
        <div class="total-box">
          <div class="title" @click="showPicker = true">
            <div class="left">{{ year }}年汇总</div>
            <!-- <img src="../../static/right-arrow.png" /> -->
            <van-icon name="arrow" />
          </div>
          <div class="content">
            <div class="item-box" v-for="(item, index) in pageData.totalList" :key="'total' + index">
              <div class="top">{{ item.value }}</div>
              <div class="bottom">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <!-- 月历 -->
        <div class="calendar">
          <div class="title">
            每年记录
            <p>({{ year }}年)</p>
          </div>
          <div style="padding: 0 15px">
            <CalendarMonth :year="year" :list="pageData.lists" @choose="dateClick" ref="ren"></CalendarMonth>
          </div>

          <div v-if="!dayObj.hasData" class="empty-sign">
            <img src="../../../../assets/images/no_sign.png" alt="" />
            <div>未提交月报</div>
          </div>
          <!-- 当日评阅记录 -->
          <div class="comment" v-else>
            <div class="status">
              指导教师评阅：
              <p :style="{ color: getCommentStatusColor }">{{ getCommentStatus }}</p>
            </div>
            <div class="comment-content" v-if="dayObj.pyzt == '2' || dayObj.pyzt == '3'  ">
              <div class="comment-title">评语</div>
              <div>{{ dayObj.pynr }}</div>
            </div>
          </div>
        </div>
        <!-- 日志详细 -->
        <div class="daily-content" v-if="dayObj.hasData" :style="{ paddingBottom: getCanEditStatus ? '0' : '15px' }">
          <div class="title">标题</div>
          <div class="content">
            {{ dayDetail.bt }}
          </div>
          <div class="title">内容</div>
          <div class="content">
            {{ dayDetail.nr }}
          </div>
          <div class="title">图片</div>
          <div class="content">
            <img :src="dayDetail.base64" alt="" />
          </div>
          <div class="title">位置</div>
          <div class="content">
            {{ dayDetail.dz }}
          </div>
          <div class="edit-button" v-if="getCanEditStatus" @click="editData">
            <van-icon name="edit" />
            <div>修改月报</div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 选择月历月份 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker :default-index="currentIndex" title="选择年" show-toolbar @cancel="showPicker = false" :columns="years" @confirm="chooseYear" />
    </van-popup>
    <!-- 选择实习月报日期 -->
    <van-popup v-model="showPickerDate" position="bottom">
      <van-datetime-picker v-model="currentDate" type="year-month" title="选择日志日期" :min-date="minDate" :max-date="maxDate" @cancel="showPickerDate = false" @confirm="chooseDate" />
    </van-popup>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
import CalendarMonth from './components/calendarMonth'
import { AMapManager } from 'vue-amap'
import { mapGetters } from 'vuex'
let amapManager = new AMapManager()
export default {
  components: {
    CalendarMonth,
  },
  data() {
    let self = this
    return {
      schoolCode:sessionStorage.getItem("schoolCode"),
      isEdit: false,
      amapManager,
      plugin: [
        {
          pName: 'Geolocation',
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：5s
          buttonPosition: 'RB', //定位按钮的停靠位置
          zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                if (status == 'complete') {
                  self.complete(result)
                } else {
                  self.$toast.fail('定位失败！')
                }
              })
            },
          },
        },
      ],
      active: 0,
      fileList: [],
      showEmpty: false,
      pageData: {
        totalList: [],
        lists: [],
      },
      form: {
        sxjhid: '',
        dz: '',
        nr: '',
        bt: '',
        ny: '',
        sxybid: '', // 只在编辑的时候传
        sqzp: '',
      },
      showPicker: false,
      showPickerDate: false,
      years: [],
      year: new Date().getFullYear().toString(),
      currentIndex: 0,
      currentDate: new Date(),
      nowDate: new Date(),
      minDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      maxDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      dayObj: {},
      month: new Date().getMonth() + 1,
      date: new Date().format('yyyy-MM'),
      delayDay: 0,
      dayDetail: {
        base64: '',
        bt: '',
        dz: '',
        nr: '',
        ny: '',
        pyjl: '',
        pynr: '',
        sxybid: '',
      },
      lastTime: '23:29',
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
      timeRange: 'getTimeRange'
    }),
    getCommentStatus() {
      if(this.schoolCode == '14475'){
        if (this.dayObj.pyzt == '1') {
          return '评阅中'
        }else if (this.dayObj.pyzt == '2') {
          return this.dayObj.pyjl
        } else if (this.dayObj.pyzt == '3') {
          return '打回'
        }
      }else{
        if (this.dayObj.pyzt == '1') {
          return '评阅中'
        } else if (this.dayObj.pyzt == '2') {
          return this.dayObj.pyjl
        }
      }
      
    },
    getCommentStatusColor() {
      if (this.dayObj.pyzt == '1') {
        return '#999999'
      } else if (this.dayObj.pyzt == '2') {
        return '#F85352'
      }
    },
    getCanEditStatus() {
      let dif = (new Date().getTime() - new Date(this.dayObj.ny.split('-')[0], parseInt(this.dayObj.ny.split('-')[1]), 0).getTime()) / 24 / 3600 / 1000
      console.log(dif)
      if (dif < this.delayDay - 1 && (this.dayObj.pyzt == '1' || this.dayObj.pyzt == '3')) {
        // 在可编辑的时间范围内，并且状态还是未评阅
        return true
      }
      return false
    },
  },
  methods: {
    /**
     * @description: 地图定位完成
     * @param {Object} result 定位结果
     */
    complete(result) {
      this.form.dz = result.formattedAddress
    },

    /**
     * @description: 打开选择日志日期弹窗，只在新增模式下可以打开
     */
    showDatePicker() {
      if (!this.isEdit) {
        this.showPickerDate = true
      }
    },
    chooseYear(e) {
      this.showPicker = false
      this.year = e.value.toString()
      this.getMonthlyData()
    },

    /**
     * @description: 选择日志日期
     * @param {Date} e 选择的日期
     */
    chooseDate(e) {
      this.showPickerDate = false
      this.form.ny = new Date(e).format('yyyy-MM')
    },

    /**
     * @description: 重新定位事件，获取地图插件通过重新调用方法，获取地址
     */
    rePosition() {
      this.form.dz = ''
      this.$refs.map.$plugins['AMap.Geolocation'].getCurrentPosition((status, result) => {
        if (status == 'complete') {
          this.complete(result)
        } else {
          this.$toast.fail('定位失败！')
        }
      })
    },
    async dateClick(index) {
      // console.log(index)
      index = index+1;
      let nyIndex = this.year+"-"+(index>=10?index:('0'+index));
      this.dayObj = {};
      this.dayDetail={
        base64: '',
        bt: '',
        dz: '',
        nr: '',
        ny: '',
        pyjl: '',
        pynr: '',
        sxybid: '',
      };
      for(let i=0;i<this.pageData.lists.length;i++){
        if(this.pageData.lists[i].ny==nyIndex){
          this.dayObj = this.pageData.lists[i];
          this.getMonthlyDetail(this.pageData.lists[i].sxybid)
          break;
        }
      }
      //this.dayObj = this.pageData.lists[index]
      //this.getMonthlyDetail(this.pageData.lists[index].sxybid)
    },
    /**
     * @description: tab监听，当tabs为1的时候请求日历接口
     * @param {*} e
     * @return {*}
     */
    tabsChange(e) {
      if (e == 1) {
        this.getMonthlyData()
        // this.dateClick(this.pageData.lists.length - 1)
      }
    },

    /**
     * @description: 文件上传，通过上传组件，直接将file赋值
     * @param {*} e
     * @return {*}
     */
    upload(e) {
      this.form.sqzp = e.file
    },

    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    editData() {
      this.isEdit = true
      this.form = {
        sxjhid: this.sxjhid,
        dz: '',
        nr: this.dayDetail.nr,
        bt: this.dayDetail.bt,
        ny: this.dayDetail.ny,
        sxybid: this.dayDetail.sxybid, // 只在编辑的时候传
        sqzp: '',
      }
      this.fileList.push({
        content: this.dayDetail.base64,
      })
      this.active = 0
      this.rePosition()
    },

    /**
     * @description: 表单提交
     * @param {*}
     * @return {*}
     */
    async onSubmit() {
      if(this.form.nr.indexOf("'") != -1){
        this.$toast('输入内容存在非法字符，请检查后重新提交!')
        return false;
      }
      this.form.sxjhid = this.sxjhid
      const res = await iApi.postMonthlyData(this.form)
      if (res.code == '1') {
        this.$toast('提交实习日志成功')
        this.form = {
          sxjhid: '',
          dz: '',
          nr: '',
          bt: '',
          ny: '',
          sxybid: '', // 只在编辑的时候传
          sqzp: '',
        }
        this.fileList = []
        this.active = 1
        this.getMonthlyData()
        // // 编辑后返回原页面
        // this.isEdit = false
        // this.fileList = []
        // if (this.dayObj != {}) {
        //   this.$refs.ren.choose = this.dayObj.date
        //   this.getDailyDetail(this.dayObj.id)
        // }
      }
    },
    async getMonthlyData() {
      const res = await iApi.getMonthlyList({
        sxjhid: this.sxjhid,
        year: this.year,
      })
      this.pageData = res.data
      // 默认选中当月
      let index = this.pageData.lists.findIndex(item => item.ny == new Date().format('yyyy-MM'))
      // console.log(index)
      if (index != -1) {
        this.dayObj = this.pageData.lists[index]
        this.$refs.ren.chooseMonth(index)
      }
    },
    async getMonthlyDetail(id) {
      if (id != '') {
        // console.log(id)
        const res = await iApi.getMonthlyDetail({
          sxybid: id,
        })
        this.dayDetail = res.data
      }
    },
  },
  async created() {
    const res = await iApi.getMonthlyTime({ sxjhid: this.sxjhid })
    // console.log(res)
    this.delayDay = parseInt(res.data.ybtjzwsj) // 可延迟的时间
    this.lastTime = res.data.date
    // 且时间不能小于计划开始时间
    let startTime = new Date(this.timeRange[0]).getTime()
    let min = new Date().getTime() - this.delayDay * 24 * 3600 * 1000
    min < startTime?this.minDate = new Date(startTime):this.minDate = new Date(min)
    let minTime = res.data.minTime;
    let maxTime = res.data.maxTime;
    this.minDate = new Date(minTime);
    this.maxDate = new Date(maxTime);
    
    // 往选择框追加年份
    for (let i = 0; i < 20; i++) {
      this.years.push({
        text: new Date().getFullYear() - i,
        value: new Date().getFullYear() - i,
      })
    }
    this.currentIndex = this.years.findIndex(item => new Date().getFullYear() == item.value)
    console.log(this.years)
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
}
.empty {
  // margin-top: 167px;
  height: calc(100vh - 86px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #666666;
  text-align: center;
  img {
    width: 159px;
    height: 154px;
    margin-bottom: 30px;
  }
  .button {
    width: 232px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    margin-top: 50px;
  }
}
.item-box {
  width: 315px;
  min-height: 50px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 12px 15px;
  .title-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      // width: 280px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .status {
      margin-left: 10px;
      min-width: 46px;
      height: 20px;
      border: 1px solid #41b29c;
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #41b29c;
    }
  }
  .date {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 5px 0;
  }
  .tip-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    p {
      color: #0088f8;
    }
  }
}
.button-box {
  width: 375px;
  height: 70px;
  background: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .van-button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px !important;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
.map {
  overflow: hidden;
  width: 0px;
  height: 0px;
}
.position {
  margin-top: 10px;
  width: 345px;
  background: #ffffff;
  padding: 15px;
  .title {
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
  }
  .content {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #b2b2b2;
    margin-top: 5px;
    display: flex;
    align-items: center;
    .van-loading {
      position: relative;
      left: 0;
      margin-right: 10px;
    }
  }
}
.textarea {
  flex-direction: column;
  height: 200px;
  overflow-y:auto;
}
.total-box {
  width: 345px;
  height: 132px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto;
  .title {
    display: flex;
    justify-content: space-between;
    padding: 16px 20px 0 20px;
    .left {
      font-weight: bold;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
    }
  }
  .content {
    display: flex;
    .item-box {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .top {
        font-weight: bold;
        font-family: PingFangSC-Semibold;
        font-size: 26px;
        line-height: 37px;
        color: #333333;
      }
      .bottom {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
    }
  }
}
.calendar {
  width: 345px;
  // height: 566px;
  // padding-bottom: 25px;
  background: #ffffff;
  border-radius: 8px;
  margin: 0 auto;
  .title {
    padding-top: 18px;
    margin-left: 18px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    p {
      font-size: 14px;
      color: #999999;
    }
  }
  .empty-sign {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 76px;
      height: 76px;
      margin-bottom: 24px;
    }
    div {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      text-align: center;
      line-height: 18px;
    }
  }
  .comment {
    padding: 15px;
    .status {
      display: flex;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      p {
        color: #f85352;
      }
    }
    .comment-content {
      margin-top: 15px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      .comment-title {
        color: #999999;
        margin-bottom: 5px;
      }
    }
  }
}
.daily-content {
  width: 315px;
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
  margin: 10px auto;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  .title {
    color: #999999;
    margin-bottom: 5px;
  }
  .content {
    margin-bottom: 10px;
    img {
      width: 70px;
      height: 70px;
      border-radius: 4px;
      display: block;
      overflow: hidden;
    }
  }
  .edit-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border-top: 1px solid #e5e5e5;
    i {
      margin-right: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/monthly.vue